import { escapeRegExp } from "lodash"

export const withoutMachineName = "Sans Machine"

export const filterMachineModels = (machineModels, search) => {
  const regex = new RegExp(escapeRegExp(search), "ig")

  const filteredMachineModels = machineModels.filter(machineModel => machineModel.name.match(regex) !== null)
  return filteredMachineModels
}

export const sortMachinesByNames = (machines, toJson = true) => {
  return machines.sort((a, b) => {
    const aName = toJson ? a.name : a.get("name")
    const bName = toJson ? b.name : b.get("name")
    return aName.localeCompare(bName, undefined, { numeric: true, sensitivity: "base" })
  })
}

export const checkCookingMachine = (machineModelId, machineTypes) => {
    if (!machineModelId || machineTypes.length === 0) return false
    
    const machineType = machineTypes.find(type => 
        type.machineModels?.some(model => model.objectId === machineModelId)
    )
    return machineType?.transformationTypes?.includes("COOKING") || false
}